module.exports = __webpack_public_path__ + "static/media/flagFiambres.e2c25b92.svg";